export enum ContentType {
    WELCOME = "welcome",
    INTEREST_AREA = "interestArea",
    DESCRIPTION = "description",
    ZODIAC = "zodiac"
  }
  
  export interface Content {
    id: string;
    key: string;
    title?: string;
    content: string;
    type: ContentType;
  }
  
  // API response interfaces
  export interface ContentResponse extends Content {}
  

  // API request interfaces
  export interface ContentCreateRequest {
    key: string;
    title?: string;
    content: string;
    type: ContentType;
  }
  
  export interface ContentUpdateRequest {
    key?: string;
    title?: string;
    content?: string;
    type?: ContentType;
  }